module.exports = __webpack_public_path__ + "img/event_err.078c105f.svg";